import { render, staticRenderFns } from "./ReadProgressBar.vue?vue&type=template&id=422a14e5&scoped=true"
import script from "./ReadProgressBar.vue?vue&type=script&lang=js"
export * from "./ReadProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a14e5",
  null
  
)

export default component.exports